<template>
  <jt-card-default
    @filter-button="openModalFilter"
  >
  <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-line-chart v-else
      :centralTitleConst="$gettext('TECHNOLOGIES')"
      :data="historyCollections"
      :xAxisData="columnsLineChart"
      :shouldTranslateXAxisData="true"
      :yAxisIndexNames="['Ton']"
    />
    <technology-dashboard-modal-filter
        v-if="modalData.show"
        v-bind="modalData"
        :filterByResidues="false"
        @submit="onChange"
        @change-visibility="(show) => (modalData.show = show)"
    />
  </jt-card-default>
</template>

<script>
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardDefault from './base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import TechnologyDashboardModalFilter from './base/TechnologyDashboardModalFilter.vue'
import lineGraphCommonMethods from 'src/components/charts/shared/lineGraphCommonMethods'
@Component({
  name: 'ResiduesByTechnologyLineGraph',
  components: {
    JtCardDefault,
    JtLineChart,
    TechnologyDashboardModalFilter
  }
})
export default class ResiduesByTechnologyLineGraph extends Vue {
  isLoading = false

  currentDate = {
    date: new Date()
  };

  modalData = {
    show: false,
    filterByResidues: false
  }

  columnsLineChart = []
  historyCollections = []

  async openModalFilter () {
    this.modalData = {
      show: true
    }
  }

  async created () {
    await this.onChange(this.currentDate)
  }

  async onChange (date) {
    this.isLoading = true
    this.doughnutData = await this.getDashboardData(date)
    const maxDay = lineGraphCommonMethods.getMaxValueAxisXLine(this.doughnutData)
    this.columnsLineChart = lineGraphCommonMethods.normalizeAxisXData(maxDay)
    const groupedDataByTechnology = this.groupByTecnology()
    const finalResult = []
    const resultNormalized = this.normalizeDataToLineGraph(groupedDataByTechnology)
    resultNormalized.forEach(array => {
      const valores = array.map((register) => (register.value / 1000).toFixed(2))
      const name = array[0].treatmentType
      finalResult.push({ data: valores, name: name })
    })

    this.historyCollections = finalResult
    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  normalizeDataToLineGraph (groupedDataByTechnology) {
    const resultNormalized = []
    groupedDataByTechnology.forEach(e => {
      resultNormalized.push(this.fillArrayWithZeroValues(e))
    })
    return resultNormalized
  }

  groupByTecnology () {
    const groupedData = this.doughnutData.reduce((acc, item) => {
      if (!acc[item.treatmentType]) {
        acc[item.treatmentType] = []
      }
      acc[item.treatmentType].push(item)
      return acc
    }, {})
    return Object.values(groupedData)
  }

  fillArrayWithZeroValues (inputArray) {
    const filledArray = []
    let currentLabel = 1

    inputArray.forEach(item => {
      while (currentLabel < item.label) {
        filledArray.push({
          label: currentLabel,
          value: '0',
          treatmentType: inputArray[0]?.treatmentType
        })
        currentLabel++
      }
      filledArray.push(item)
      currentLabel++
    })
    return filledArray
  }

  async getDashboardData (form) {
    const objectRequest = {
      month: form.date.getMonth() + 1,
      year: form.date.getFullYear(),
      composition: [{
        technologies: form.technologies
      }]
    }
    const { registros } = await repository.resolveLogic('technologyDashboard.searchTicketsGroupByTreatmentType', { ...objectRequest })

    return registros.map((registro) => {
      return {
        label: registro.day,
        value: registro.value,
        treatmentType: registro.treatmentType
      }
    })
  }
}
</script>

<style lang='stylus' scoped>

</style>
